import { BomItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { BomItemPointer } from '../../../../model/Project/BomItemPointer'
import { bomItemSelector } from './bomItemSelector'

export const bomItemIsOpenSelector =
  (bomItemPointer: BomItemPointer) => (state: RootAppState) => {
    if (!bomItemPointer || !bomItemPointer.id) return null

    const bomItem = bomItemSelector(state, bomItemPointer)

    if (!bomItem) return false

    return bomItem.type === BomItemType.partType ||
      bomItem.type === BomItemType.partInstance ||
      bomItem.type === BomItemType.project
      ? false
      : bomItem.isOpen
  }
